<template>
    <section class='viewsrhqyBaseManagecomponents_baseModal'>
        <el-dialog :title="title" :visible.sync="visible" width="680px" @close="onReset">
            <div class="pr-20">
                <el-form ref="form" :model="form" label-width="120px" :rules="rules">
                    <el-form-item label="基地名称">
                        {{ baseInfo.com_name }}
                    </el-form-item>
                    <el-form-item label="基地坐标" prop="coordinate">
                        <el-input placeholder="请输入基地坐标" v-model.trim="form.coordinate"></el-input>
                    </el-form-item>
                    <el-form-item label="坐标名称" prop="name">
                        <el-input placeholder="请输入坐标名称" v-model.trim="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="基地打卡范围" prop="range">
                        <el-input v-model.trim="form.range" placeholder="请输入打卡范围(米)"></el-input>
                    </el-form-item>
                    <el-form-item label="发货打卡范围" prop="delivery_range">
                        <el-input v-model.trim="form.delivery_range" placeholder="请输入发货打卡范围(米)"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="visible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="onOk">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { cloneDeep } from 'lodash'
export default {
    data() {
        const validatePositiveInteger = (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
                callback();
                return;
            }

            if (!/^[1-9]\d*$/.test(String(value))) {
                callback(new Error('请输入正整数'));
                return;
            }

            callback();
        };

        return {
            visible: false,
            baseList: [],
            form: {},
            rules: {
                coordinate: [
                    { required: true, message: '请输入基地坐标', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入坐标名称', trigger: 'blur' }
                ],
                range: [
                    { required: true, message: '请输入打卡范围(米)', trigger: 'blur' }
                ],
                delivery_range: [
                    { validator: validatePositiveInteger, trigger: 'blur' }
                ],
            }
        };
    },
    computed: {
        ...mapGetters([
            "baseInfo",
        ]),
        title() {
            return this.form.id ? "修改基地坐标" : "新建基地坐标";
        }
    },
    methods: {
        // 打开弹窗时补齐发货打卡范围默认值，避免新增和编辑场景回填结构不一致。
        openModal(row) {
            if (row) {
                this.form = cloneDeep(row);
            } else {
                this.form = {
                    delivery_range: "",
                };
            }
            this.form.delivery_range = this.form.delivery_range || "";
            this.visible = true;
        },
        onOk() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const url = this.form.id ? "/api/contact/update_coordinate" : "/api/contact/create_coordinate";
                    this.$common.http({
                        url,
                        data: this.form
                    }).then(() => {
                        this.$message.success(`${this.form.id ? "修改" : "添加"}成功`);
                        this.visible = false;
                        this.$emit("ok");
                    })
                }
            })
        },
        onReset() {
            Object.keys(this.form).map((key) => {
                this.$set(this.form, key, null)
            })
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        }
    }
}

</script>
